<template>
  <v-container fluid class="itemsubcategory-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Item </v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Photo</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Create New Item Subcategory</p>
                        <v-text-field
                          class="mb-4"
                          v-model="itemsubcategory.itemsubcategorycode"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Item Subcategory Code"
                          persistent-hint
                          single-line hint="Enter the itemsubcategory Code">
                        </v-text-field>
                        <v-text-field
                          class="mb-4"
                          v-model="itemsubcategory.itemsubcategoryname"
                          v-bind:error="errorindex == 1"
                          outlined
                          dense
                          placeholder="Item Subcategory Name"
                          persistent-hint
                          single-line hint="Enter the itemsubcategory name">
                        </v-text-field>
                        <v-select
                          class="mb-4"
                          :items="itemcategories.map(x => {
                            return {text: x.itemcategoryname, value: x._id};
                            })"
                          v-model="itemsubcategory.itemcategoryid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Category"
                          persistent-hint
                          single-line hint="Please choose the item category">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items=items
                          v-model="itemsubcategory.itemsubcategorytype"
                          v-bind:error="errorindex == 3"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the itemsubcategory type">
                        </v-select>
                          <v-switch
                            v-model="itemsubcategory.itemsubcategorystatus"
                            color="primary"
                            v-bind:label="itemsubcategory.itemsubcategorystatus"
                            value="Active"
                          ></v-switch>
                        <div class="d-flex justify-end">

                        </div>
                        <div class="d-flex justify-center">
                        <v-btn
                            to="/itemsubcategory/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>

                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <v-form>
                        <p class="text-h5">Upload Photo</p>
                        <p>Photo:</p>

                        <v-file-input label="File input" v-on:change="onFileChange" accept="image/*" />
                        <v-img contain max-height="150" max-width="250" :src="imageurl" />
                        <v-spacer min-height="20">&nbsp;</v-spacer>
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="createItemSubcategory()">
                            Save
                          </v-btn>
                        </div>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>

        </v-stepper>
      </v-col>
    </v-row>
  </v-container>

</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      step: 1,
      imageurl: undefined,
      itemsubcategory: {
        itemsubcategorystatus: 'Active'
      },
      items: ['Item Subcategory', 'Other Item Subcategory'],
      error: undefined,
      haserror: false,
      errorindex: undefined,
    }
  },

  methods: {
    ...mapActions('ItemSubcategory', ['createItemSubcategoryRequest','getItemSubcategorysRequest']),
    ...mapActions('ItemCategory', ['getItemCategoriesRequest']),
    checkError(){
      if(!this.itemsubcategory.itemsubcategorycode){
        this.haserrors = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.itemsubcategory.itemsubcategoryname){
        this.haserrors = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.itemsubcategory.itemcategoryid){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      if(!this.itemsubcategory.itemsubcategorytype){
        this.haserrors = true;
        this.errorindex = 3;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    createItemSubcategory() {
      this.createItemSubcategoryRequest(this.itemsubcategory);
      this.getItemSubcategorysRequest();
      router.push('/itemsubcategory/list');
    },
    onFileChange(file) {
      if (!file) {return;}
      this.itemsubcategory.itemsubcategoryimage = file;
      this.itemsubcategory.imagename = file.name;
      const reader = new FileReader();
      reader.onload = e => {
        this.imageurl = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
  computed: {
    ...mapState('ItemSubcategory', ['isReceiving']),
    ...mapState('ItemCategory', ['itemcategories']),
  },
  created () {
    if(this.itemcategories.length==0) this.getItemCategoriesRequest();
  },
}
</script>

<style src="./Add.scss" lang="scss"></style>
